module.exports = __webpack_public_path__ + "img/crusher.d7e72537.png";